import { render, staticRenderFns } from "./ReferralPromotionTable.vue?vue&type=template&id=59d3b799&"
import script from "./ReferralPromotionTable.vue?vue&type=script&lang=js&"
export * from "./ReferralPromotionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports